import React, { memo, createContext, useContext, useEffect, useState } from 'react';
import { createElement } from 'react';
import { useSelector } from 'react-redux';
import { MenuItemLink } from 'react-admin';
import { withRouter } from 'react-router-dom';
import ServiceIcon from '@material-ui/icons/Tune';
import HomeIcon from '@material-ui/icons/Home';
import ContactsIcon from '@material-ui/icons/Contacts';
import GroupIcon from '@material-ui/icons/Group';
import ComputerIcon from '@material-ui/icons/Computer';
import {
  usePermissions,
} from 'utils/permissions';
import { makeStyles } from "@material-ui/core/styles";
import request from "./utils/request";
import { HostContext } from "./App";
import { Typography } from "@material-ui/core";

const MenuContext = createContext({onMenuClick: () => {}});

const MenuItem = ({permission, leftIcon, primaryText, to}) => {
    const open = useSelector(state => state.admin.ui.sidebarOpen);
    const {onMenuClick} = useContext(MenuContext);

    const {loaded, hasPermission} = usePermissions(permission);

    if((!loaded || !hasPermission) && permission !== undefined ) {
        return null;
    }

    return (
        <MenuItemLink
            to={to}
            primaryText={primaryText}
            leftIcon={leftIcon}
            onClick={onMenuClick}
            sidebarIsOpen={open}
        />  
    );
};


const Menu = ({ onMenuClick, logout }) => {
    
    return (
        <MenuContext.Provider value={{onMenuClick}}>
            <MenuItemLink
                to="/"
                primaryText="Dashboard"
                leftIcon={<HomeIcon />}
            />
            <MenuItem
                to={`/Customer`}
                primaryText={'Customers'}
                leftIcon={createElement(ContactsIcon)}
            />
            <MenuItem
                to={`/User`}
                primaryText={'Users'}
                leftIcon={createElement(GroupIcon)}
            />
            <MenuItem
                to={`/Device`}
                primaryText={'Devices'}
                leftIcon={createElement(ComputerIcon)}
            />
            <MenuItem
                to={`/ManagementService`}
                primaryText={'Services'}
                leftIcon={createElement(ServiceIcon)}
            />
          <VersionInfo />
        </MenuContext.Provider>
    );
}

const useStyles = makeStyles((theme) => ({
  versionInfo: {
    opacity: '0.25 !important',
    fontSize: '.67rem',
    paddingTop: theme.spacing(2),
    paddingLeft: theme.spacing(2),
  }
}));

const VersionInfo = memo(() => {
  const styles = useStyles();

  const { apiHost } = useContext(HostContext);

  const [cmsVersion, setCmsVersion] = useState(null);
  const [apiVersion, setApiVersion] = useState(null);

  // set CMS version
  useEffect( () => {
    const run = async () => {
      const tag = process.env?.REACT_APP_BUILD_TAG?.trim() || false;
      const commit = process.env?.REACT_APP_BUILD_COMMIT?.trim() || false;
      const stage = process.env?.REACT_APP_STAGE?.trim() || false;

      if (tag) {
        setCmsVersion(tag);
      } else if (commit) {
        setCmsVersion(commit)
      } else if (stage) {
        setCmsVersion(stage);
      }
    };

    run();
  }, [])

  // get API version
  useEffect(() => {
      const run = async () => {
      const { data } = await request(apiHost).get('/api/version-info');
      const { tag, commit } = data || {};

      if (tag && tag.trim().length) {
        setApiVersion(tag.trim());
      } else if (commit && commit.trim().length) {
        setApiVersion(commit.trim());
      }
    }
    run();
  }, [apiHost]);

  return (
    <>
        <Typography className={styles.versionInfo}>
          { cmsVersion && `CMS: ${ cmsVersion }` }
          { cmsVersion && apiVersion && <br /> }
          { apiVersion && `API: ${ apiVersion }` }
        </Typography>
    </>

  );
});

export default withRouter(Menu);